// extracted by mini-css-extract-plugin
module.exports = {"buyer-vendor-view":"buyer-vendor-view_buyer-vendor-view__1o8mq","buyer-vendor-view-body":"buyer-vendor-view_buyer-vendor-view-body__3r-Uj"};